<footer class="footer fixed-bottom footer-light navbar-border navbar-shadow">
    <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2"> <span class="float-md-left d-block d-md-inline-block footer_text">All Rights Reserved @ My Fortress </span> <span class="float-md-right d-block d-md-inline-blockd-none d-lg-block footer_text">
        <!-- Crafted with <i class="ft-heart pink"></i> by FSL. -->
    </span> </p>
</footer>